import request from '@/utils/request'

// 报警配置 - 列表
export const getWarningsetList = (params: any) =>
  request({
    url: 'warning/set/list',
    method: 'get',
    params
  })
// 报警配置 - 新增
export const addWarningset = (params: any) =>
  request({
    url: 'warning/set/add',
    method: 'post',
    params
  })
// 报警配置 - 修改
export const putWarningset = (params: any) =>
  request({
    url: `warning/set/put/${params.id}`,
    method: 'put',
    params
  })
// 报警配置 - 删除
export const delWarningset = (params: any) =>
  request({
    url: `warning/set/del/${params.id}`,
    method: 'delete',
    params
  })
// 实时报警 - 列表
export const getWarningRealTimeList = (params: any) =>
  request({
  url: 'warning/realTime/list',
  method: 'get',
  params
})
// 报警记录
export const getWarningLogList = (params: any) =>
  request({
    url: 'warning/log/list',
    method: 'get',
    params
  })
